<template>
  <div class="hotel-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/hotel/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>星级酒店纵览</span>
    </p>
    <div
      class="section-container wow animate__fadeIn"
      data-wow-duration="500ms"
    >
      <el-row :gutter="20">
        <el-col :span="8" class="custom-col">
          <img src="../../../assets//images/hotel/1.jpg" alt="" />
        </el-col>
        <el-col :span="8" class="custom-col">
          <img src="../../../assets//images/hotel/2.jpg" alt="" />
        </el-col>
        <el-col :span="8" class="custom-col">
          <img src="../../../assets//images/hotel/3.jpg" alt="" />
        </el-col>
        <el-col :span="8" class="custom-col">
          <img src="../../../assets//images/hotel/4.jpg" alt="" />
        </el-col>
        <el-col :span="8" class="custom-col">
          <img src="../../../assets//images/hotel/5.jpg" alt="" />
        </el-col>
        <el-col :span="8" class="custom-col">
          <img src="../../../assets//images/hotel/6.jpg" alt="" />
        </el-col>
      </el-row>
    </div>
    <div class="section-container">
      <div v-for="(item, index) in list" :key="item.name + index">
        <project-show :data="item"></project-show>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectShow from "@/components/projectShow";

export default {
  name: "HotelPage",
  components: {
    ProjectShow,
  },
  data() {
    return {
      list: [
        {
          name: "成都新希望",
          label: "高新皇冠假日酒店®️",
          title: "Crowne Plaza Chengdu West",
          desc: [
            "酒店概述",
            "成都新希望高新皇冠假日酒店®️位于成都市高新西区内，雅致写意的设计风格，舒适宽敞的灵动空间，开启独具一格的旅游度假居住体验。交通畅达便捷，距离百草路地铁站15分钟步行路程，距离茶店子客运站仅10分钟车程。作为高新西区地标性五星级酒店，服务涵盖奢华的客房、覆盖各处的免费WiFi、室内游泳池、健身中心、免费内部停车场以及收费机场班车。提供新鲜、舒适、便捷的住宿体验，是注重高效的商务、旅游人士的上等之选。",
          ],
          footer: [
            "Tel：+86（28）8782 6666",
            "Add：四川省成都市高新西区西芯大道1号",
          ],
          link: "https://www.ihg.com.cn/crowneplaza/hotels/cn/zh/chengdu/ctucp/hoteldetail",
          city: "中国·成都",
          images: [
            require("../../../assets/images/hotel/gxhgjr-1.png"),
            require("../../../assets/images/hotel/gxhgjr-2.png"),
            require("../../../assets/images/hotel/gxhgjr-3.png"),
            require("../../../assets/images/hotel/gxhgjr-4.png"),
            require("../../../assets/images/hotel/gxhgjr-5.png"),
            require("../../../assets/images/hotel/gxhgjr-6.png"),
          ],
        },
        {
          name: "成都新希望",
          label: "武侯智选假日酒店®️",
          title: "Holiday Inn Express Chengdu",
          desc: [
            "酒店概述",
            "成都新希望武侯智选假日酒店®️由世界著名的洲际酒店集团管理。酒店位于成都市西南武侯区，毗邻成都地铁3号线红牌楼站B出口。该区为传统的文化住宅区域，毗邻武侯祠，遥望杜甫草堂和望江楼等国家级名胜古迹。酒店遵照全球标准、百项检测，配备国际门禁系统，高效灭菌，提供365天无微不至的用心服务。为注重高效的商旅常客提供新鲜、舒适、便捷的住宿体验。",
          ],
          footer: [
            "Tel：+86 （28）8506 0888",
            "Add：四川省成都市武侯区二环路西一段5号",
          ],
          link: "https://www.ihg.com/holidayinnexpress/hotels/cn/zh/chengdu/ctuwh/hoteldetail",
          city: "中国·成都",
          images: [
            require("../../../assets/images/hotel/whzxjrjd-1.png"),
            require("../../../assets/images/hotel/whzxjrjd-2.png"),
            require("../../../assets/images/hotel/whzxjrjd-3.png"),
            require("../../../assets/images/hotel/whzxjrjd-4.png"),
            require("../../../assets/images/hotel/whzxjrjd-5.png"),
            require("../../../assets/images/hotel/whzxjrjd-6.png"),
          ],
        },
        {
          name: "成都新希望",
          label: "高新中心假日酒店®️",
          title: "Holiday Inn Hi-Tech Center Chengdu",
          desc: [
            "酒店概述",
            "成都新希望高新中心假日酒店®️位于高新西区腹地，所在区域高新技术产业研究与开发企业云集。酒店地理位置优越，交通快捷，距离成都双流国际机场仅30分钟车程，搭乘地铁2号线即可直达成都市中心天府广场。亦可轻松游览中海国际社区，非物质文化遗产博览公园，世界著名的成都熊猫基地，青城山，以及令人兴奋的欢乐谷主题公园等景点，让旅程更为丰富多彩。",
          ],
          footer: [
            "Tel：+86（28）8282 2222",
            "Add：四川省成都市高新西区西芯大道1号附1号",
          ],
          link: "https://www.ihg.com.cn/holidayinn/hotels/cn/zh/chengdu/ctuht/hoteldetail",
          city: "中国·成都",
          images: [
            require("../../../assets/images/hotel/gxzxjrjd-1.png"),
            require("../../../assets/images/hotel/gxzxjrjd-2.png"),
            require("../../../assets/images/hotel/gxzxjrjd-3.png"),
            require("../../../assets/images/hotel/gxzxjrjd-4.png"),
            require("../../../assets/images/hotel/gxzxjrjd-5.png"),
            require("../../../assets/images/hotel/gxzxjrjd-6.png"),
            require("../../../assets/images/hotel/gxzxjrjd-7.png"),
          ],
        },
        {
          name: "青岛新希望",
          label: "崂山诺富特酒店®️",
          title: "Newhope Novotel Qingdao",
          desc: [
            "酒店概述",
            "青岛崂山诺富特酒店®️位于青岛崂山区，靠近崂山风景区。酒店距离青岛会展中心约10 分钟车程，距离青岛流亭机场和火车北站约 35 分钟车程。酒店拥有 247 间宽敞舒适的客房，提供现代化的设计、设施齐全的健身房、室内儿童游乐室、全天候餐厅、1000 平方米（10764 平方英尺）的宴会厅，以及高速无线网络，是商务和休闲旅行的上乘选择。",
          ],
          footer: [
            "Tel：+86（532）5571 9555",
            "Add：山东省青岛市崂山区九水东路592-26号",
          ],
          link: "https://www.accorhotels.com/zh/hotel-B0Y3-%E9%9D%92%E5%B2%9B%E5%B4%82%E5%B1%B1%E8%AF%BA%E5%AF%8C%E7%89%B9%E9%85%92%E5%BA%97%EF%BC%882018-%E5%B9%B4-8-%E6%9C%88%EF%BC%89/index.shtml",
          city: "中国·青岛",
          images: [
            require("../../../assets/images/hotel/lsnftjd-1.png"),
            require("../../../assets/images/hotel/lsnftjd-2.png"),
            require("../../../assets/images/hotel/lsnftjd-3.png"),
            require("../../../assets/images/hotel/lsnftjd-4.png"),
            require("../../../assets/images/hotel/lsnftjd-5.png"),
            require("../../../assets/images/hotel/lsnftjd-6.png"),
          ],
        },
        {
          name: "温州新希望",
          label: "希尔顿酒店®️",
          title: "Hilton Hotel Wenzhou",
          desc: [
            "酒店概述",
            "温州新希望希尔顿酒店®️位于温州三江立体城，酒店为国际知名酒店管理集团旗下五星级“希尔顿”品牌，目前规划有243个客房，超过3000㎡的会议空间，其中包含2个可举办各种大型会议及婚宴的无柱宴会厅。超过26个中餐包间，以及配套完善的健身、游泳设施。",
          ],
          footer: ["Tel：敬请期待", "Add：浙江省温州市三江立体城"],
          city: "中国·温州",
          images: [
            require("../../../assets/images/hotel/wzxedjd-1.png"),
            require("../../../assets/images/hotel/wzxedjd-2.png"),
            require("../../../assets/images/hotel/wzxedjd-3.png"),
            require("../../../assets/images/hotel/wzxedjd-4.png"),
          ],
        },
        {
          name: "昆明新希望",
          label: "希尔顿花园酒店®️",
          title: "Hilton Hotel Kunming",
          desc: [
            "酒店概述",
            "昆明新希望希尔顿花园酒店®️位于昆明大商汇旁，紧邻广福路，为国际知名酒店集团希尔顿旗下四星级品牌“希尔顿花园”。目前规划有300间客房，超过1500㎡的会议设施，能满足不同需求的公司客源以及商务团队。",
          ],
          footer: ["Tel：敬请期待", "Add：云南省昆明市大商汇"],
          city: "中国·昆明",
          images: [
            require("../../../assets/images/hotel/kmxedhyjd-1.png"),
            require("../../../assets/images/hotel/kmxedhyjd-2.png"),
            require("../../../assets/images/hotel/kmxedhyjd-3.png"),
            require("../../../assets/images/hotel/kmxedhyjd-4.png"),
          ],
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.hotel-container {
  .custom-col {
    margin-top: 20px;
    > img {
      max-width: 100%;
    }
  }
}
</style>
